import React, { useState, useEffect } from 'react';
import {
  Typography,
  TextField,
  Button,
  Grid,
  DialogContent,
  DialogActions,
  DialogTitle,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import ScanningDialog from './components/ScanningDialog';

const PacFormPage = ({ onClose, onSubmit, initialData = {} }) => {
  const [formData, setFormData] = useState({
    insuranceCompany: initialData.insuranceCompany || '',
    accountHolder: initialData.accountHolder || '',
    bankName: initialData.bankName || '',
    transitNumber: initialData.transitNumber || '',
    institutionNumber: initialData.institutionNumber || '',
    accountNumber: initialData.accountNumber || '',
  });

  const [openScanningDialog, setOpenScanningDialog] = useState(true);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value
    });
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <>
      <ScanningDialog 
        open={openScanningDialog}
        onComplete={() => setOpenScanningDialog(false)}
      />

      <DialogTitle 
        sx={{ 
          backgroundColor: '#f8f9fa',
          color: '#1565c0',
          p: 3,
          textAlign: 'center'
        }}
      >
        <Typography variant="h5" component="div" sx={{ fontWeight: 500 }}>
          PAC Form Information
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ p: 3 }}>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              mb: 4, 
              color: '#666',
              textAlign: 'center'
            }}
          >
            Please verify the bank information extracted from your void cheque
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" required>
                <InputLabel>Insurance Company</InputLabel>
                <Select
                  name="insuranceCompany"
                  value={formData.insuranceCompany}
                  label="Insurance Company"
                  onChange={handleChange}
                >
                  <MenuItem value="aviva">Aviva Insurance</MenuItem>
                  <MenuItem value="intact">Intact Insurance</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="accountHolder"
                label="Account Holder Name"
                value={formData.accountHolder}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="bankName"
                label="Bank Name"
                value={formData.bankName}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12}>
              <Box 
                sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  my: 2,
                  '&::before, &::after': {
                    content: '""',
                    flex: 1,
                    borderBottom: '1px solid #e0e0e0'
                  }
                }}
              >
                <Typography 
                  variant="subtitle2" 
                  sx={{ 
                    px: 3,
                    color: '#1976d2',
                    fontWeight: 500,
                    textAlign: 'center'
                  }}
                >
                  Bank Account Details
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                required
                fullWidth
                name="transitNumber"
                label="Transit Number"
                value={formData.transitNumber}
                onChange={handleChange}
                inputProps={{ maxLength: 5 }}
                helperText="5 digits"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                fullWidth
                name="institutionNumber"
                label="Institution Number"
                value={formData.institutionNumber}
                onChange={handleChange}
                inputProps={{ maxLength: 3 }}
                helperText="3 digits"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                fullWidth
                name="accountNumber"
                label="Account Number"
                value={formData.accountNumber}
                onChange={handleChange}
                inputProps={{ maxLength: 12 }}
                helperText="Up to 12 digits"
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions 
        sx={{ 
          p: 3, 
          borderTop: '1px solid #e0e0e0',
          backgroundColor: '#f8f9fa'
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ mr: 1 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0',
            },
          }}
        >
          Generate PAC Form
        </Button>
      </DialogActions>
    </>
  );
};

export default PacFormPage; 